import axios from 'axios';
import store from '@/store'

/**
 * 自定义Axios实例
 */
const AJAX = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout: 800000,
    withCredentials: false // true: 本地启用服务处理跨域， false：服务器处理跨域
});
const AJAXFILE = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout: 800000,
    responseType:'blob',
    withCredentials: false // true: 本地启用服务处理跨域， false：服务器处理跨域
});
// 添加请求拦截器（AJAX 和 AJAXFILE 共用，保证文件下载请求也带上 token）
const onRequest = function (config) {
    // 在发送请求之前做些什么
    // if (process.env.NODE_ENV === 'development') {
    //     config.url = `http://${location.host}` + config.url; // 自定义反向代理，可以在demo阶段打开看下请求效果
    // }

    if (store.getters.token) {
       config.headers['token'] = store.getters.token
    }

    // A-android
    // I-IOS
    // F-前端网页
    // B-中医在线后台
    config.headers['sourceType'] = 'F'
    return config;
}
const onRequestError = function (error) {
    // 对请求错误做些什么
    
    return Promise.reject(error);
}
AJAX.interceptors.request.use(onRequest, onRequestError);
AJAXFILE.interceptors.request.use(onRequest, onRequestError);

// 登录失效（token 过期）：清除本地登录信息并回到首页
const logoutOnExpired = function () {
    window.sessionStorage.clear();
    window.localStorage.clear();
    window.location.href="/";
}

// 是否登录失效：data 是 map（对象）且 data['code'] == 401
const isTokenExpired = function (data) {
    return !!data && typeof data === 'object' && data['code'] == 401
}

// 文件下载出错时后端返回的是 JSON（以 blob 形式到达，content-type 可能带 charset 或是 text/plain），
// 先解析成 map；正常的文件内容（如 pdf）不是 JSON，原样返回
const blobToMap = async function (data) {
    if(data instanceof Blob && /json|text/i.test(data.type)) {
        try {
            return JSON.parse(await data.text())
        } catch (e) {
            // 解析失败就按普通内容处理
        }
    }
    return data
}

// 添加响应拦截器
AJAX.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    var rs = response.data
    if(rs.code == 401) {
        window.sessionStorage.clear();
        window.localStorage.clear();
        window.location.href="/";
        return {};
    }
    return rs;
}, function (error) {
    // 对响应错误做点什么，比如400、401、402等等
    // HTTP 状态码非 2xx 时，后端返回的 JSON 在 error.response.data 里
    if(error.response && isTokenExpired(error.response.data)) {
        logoutOnExpired();
    }
    return Promise.reject(error);
});

AJAXFILE.interceptors.response.use(async function (response) {
    if(isTokenExpired(await blobToMap(response.data))) {
        logoutOnExpired();
    }
    return response;
}, async function (error) {
    if(error.response && isTokenExpired(await blobToMap(error.response.data))) {
        logoutOnExpired();
    }
    return Promise.reject(error);
});

// 定义对外Get、Post、File请求
export default {
    get(url, param = {}, headers = {}) {
        if(location.href.indexOf('/user/') != -1 && !store.getters.token) {
            return new Promise(function(reslove,reject){
                reslove({'code': 211, msg: '未登錄，請先登錄'})
            })
        }
        return AJAX.get(url, {
            params: param,
            headers,
        })
    },
    post(url, param = null, headers = {}) {
        if(location.href.indexOf('/user/') != -1 && !store.getters.token) {
            return new Promise(function(reslove,reject){
                reslove({'code': 211, msg: '未登錄，請先登錄'})
            })
        }
        return AJAX.post(url, param, headers)
    },
    put(url, param = null, headers = {}) {
        return AJAX.put(url, param, {
            headers,
        })
    },
    downloadFile(url, param = {}, headers = {}) {
        return AJAXFILE.get(url, {
            params: param,
            headers,
        })
    },
    file(url, param = null, headers = {}) {
        return AJAX.post(url, param, {
            headers: Object.assign({
                'Content-Type': 'multipart/form-data'
            }, headers)
        })
    },
    delete(url, param = null, headers = {}) {
        return AJAX.delete(url, {
            param,
            headers: Object.assign({
                'Content-Type': 'multipart/form-data'
            }, headers)
        })
    }
}
export const baseUrl = process.env.VUE_APP_API